import * as React from "react";
import { ThunkDispatch } from "redux-thunk";
import { connect } from "react-redux";

import { authorize } from "reauthorize";

import { ConfirmedButton } from "@teamprevent/common/confirmedButton/ConfirmedButton";

import { AppState } from "../../model";
import { deactivateCustomerUser } from "../../actions";
import { ADMIN_ROLES } from "../../../../auth/model";

interface MergedProps {
    deactivate: () => void;
}

class DeactivateButton extends React.Component<MergedProps> {
    constructor(props: MergedProps) {
        super(props);
        this.deactivate = this.deactivate.bind(this);
    }

    public render() {
        return (
            <ConfirmedButton
                icon="power"
                className="negative ui button"
                content="Deactivate"
                floated="left"
                onClick={this.deactivate}
                promptText="Are you sure you want to make this user inactive?
                By making the customer users inactive,
                you are removing them from any cases which they are associated with. Do you wish to continue?
                Type 'DEACTIVATE' and click confirm to make the user inactive."
                headingText="Deactivate Customer User"
                typeToConfirmText="DEACTIVATE"
            />
        );
    }

    private deactivate() {
        this.props.deactivate();
    }
}

interface StateProps {
    id: string;
}

interface DispatchProps {
    dispatchDeactivate: (id: string) => void;
}

function mapStateToProps(state: AppState): StateProps {
    return {
        id: state.router.params.customerUserId
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch<AppState, undefined, any>): DispatchProps {
    return {
        dispatchDeactivate: (id) => dispatch(deactivateCustomerUser(id))
    };
}

function mergeProps(propsFromState: StateProps, propsFromDispatch: DispatchProps): MergedProps {
    return {
        deactivate: () => propsFromDispatch.dispatchDeactivate(propsFromState.id)
    };
}

export default authorize([ADMIN_ROLES.SENIOR_ADMINISTRATOR.name, ADMIN_ROLES.ADMINISTRATOR.name, ADMIN_ROLES.SYSTEM_ADMIN.name])(
    connect(mapStateToProps, mapDispatchToProps, mergeProps)(DeactivateButton));
